// extracted by mini-css-extract-plugin
export default {"button":"FloatingAccessibilityButton_button__mDjgD","button--active":"FloatingAccessibilityButton_button--active__OGZ0g","icon":"FloatingAccessibilityButton_icon__c52Jj"};